import React from 'react'
import { isMobile } from 'react-device-detect'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcFlexBox,
  Section,
  SectionContent,
  SectionTitle,
} from 'pixel-base'

import BillingPlanCard from './BillingPlanCard'
const ChangePlan = () => {
  const breadcrumbs = [
    {
      name: 'Settings',
      active: false,
    },
    {
      name: 'Subscription Plans',
      link: '/admin/subscription-plans',
      active: false,
    },
    {
      name: 'Change plan',
      active: true,
    },
  ]
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 16px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>
      <Section
        style={{ backgroundColor: 'rgb(237, 242, 249)', padding: '20px 20px' }}
      >
        <SectionTitle>Choose The Best Plan For Your Business</SectionTitle>
        <SectionContent isMobile={isMobile}>
          <BillingPlanCard />
        </SectionContent>
      </Section>
    </>
  )
}

export default ChangePlan
